import { FormProvider, useForm } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Modal, SimpleLabel, Svg } from '@hopskipdrive/react-components';
import { InvoiceGroup } from '@rideiq/organizers/features/InvoiceGroups/types';
import { useEditInvoiceGroup } from '@rideiq/organizers/pages/BillingInvoiceGroups';
import { ButtonLink } from '@rideiq/shared/components';
import { Button } from '@rideiq/shared/components/Button';
import { Text } from '@rideiq/shared/components/Text';
import { variables } from '@rideiq/shared/components/variables';

import { InvoiceGroupForm, InvoiceGroupFormData } from '../InvoiceGroupForm';
import { invoiceGroupSchema } from '../InvoiceGroupForm/validationSchema';
import { CloseButton } from '../styles';

export const EditInvoiceGroupModal = () => {
  const { isSubmitting, handleSubmit } = useEditInvoiceGroup();
  const { state } = useLocation();
  const invoiceGroup = state?.invoiceGroup as InvoiceGroup | undefined;

  const methods = useForm<InvoiceGroupFormData>({
    defaultValues: {
      name: invoiceGroup?.name ?? '',
      poNumber: invoiceGroup?.poNumber ?? '',
    },
    resolver: yupResolver(invoiceGroupSchema),
  });

  return (
    <Modal open={true} data-testid="edit-invoice-group-modal">
      <Modal.Title>
        <Box display="flex" alignItems="flex-start" justifyContent="space-between">
          <Box display="flex" flexDirection="column" gap="6px" flex="1 0 0" alignItems="flex-start">
            <Text variant="h1" fontWeight={700}>
              Edit Invoice Group
            </Text>
            {invoiceGroup?.isDefault && (
              <SimpleLabel
                label="Default"
                bgColor="neutral95"
                style={{ color: variables.colorPalette.neutralVariant60 }}
              />
            )}
          </Box>
          <CloseButton to="/settings/invoice_groups" aria-label="Close" type="button">
            <Svg height="20px" icon="close-outlined" />
          </CloseButton>
        </Box>
      </Modal.Title>
      <Modal.Content>
        <FormProvider {...methods}>
          <InvoiceGroupForm
            formId="edit-invoice-group-form"
            onSubmit={methods.handleSubmit(
              (data) => invoiceGroup && handleSubmit(invoiceGroup.id, data, invoiceGroup?.isDefault)
            )}
          />
        </FormProvider>
      </Modal.Content>
      <Modal.Actions>
        <ButtonLink color="tertiary" to="/settings/invoice_groups" disabled={isSubmitting}>
          Never mind
        </ButtonLink>
        <Button
          color="primary"
          type="submit"
          form="edit-invoice-group-form"
          loading={isSubmitting}
          sx={{ height: '36px', minWidth: '90px' }}
        >
          Save
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
